/**
 * Save .svg files in the ./svgs folder
 * and remove the outest layer fill properties
 */

import React, { FunctionComponent, memo, ReactElement } from 'react'
import { ReactComponent as Check } from './svgs/check.svg'
import { ReactComponent as Email } from './svgs/email.svg'
import { ReactComponent as SendEmail } from './svgs/send-email.svg'
import { ReactComponent as StarEmpty } from './svgs/star-empty.svg'
import { ReactComponent as StarFilled } from './svgs/star-filled.svg'
import { ReactComponent as ThumbsUp } from './svgs/thumbs-up.svg'
import { ReactComponent as Submit } from './svgs/submit.svg'
import { ReactComponent as PinPlus } from './svgs/pin-plus.svg'
import { ReactComponent as PinX } from './svgs/pin-x.svg'
import { ReactComponent as Trash } from './svgs/trash.svg'
import { ReactComponent as Archive } from './svgs/archive.svg'
import { ReactComponent as Live } from './svgs/live.svg'
import { ReactComponent as Replay } from './svgs/replay.svg'

export enum SvgType {
  EMAIL,
  SEND_EMAIL,
  THUMBS_UP,
  STAR_EMPTY,
  STAR_FILLED,
  CHECK,
  SUBMIT,
  PIN_PLUS,
  PIN_X,
  TRASH,
  ARCHIVE,
  LIVE,
  REPLAY,
}

export interface SvgIconProps {
  type: SvgType
  className?: string
  [key: string]: any
}

export const SvgIcon: FunctionComponent<SvgIconProps> = memo(({ type, className, ...svgProps }): ReactElement<void> => {
  const renderIcon = () => {
    switch (type) {
      case SvgType.EMAIL:
        return <Email className={className} {...svgProps} />
      case SvgType.SEND_EMAIL:
        return <SendEmail className={className} {...svgProps} />
      case SvgType.THUMBS_UP:
        return <ThumbsUp className={className} {...svgProps} />
      case SvgType.STAR_EMPTY:
        return <StarEmpty className={className} {...svgProps} />
      case SvgType.STAR_FILLED:
        return <StarFilled className={className} {...svgProps} />
      case SvgType.CHECK:
        return <Check className={className} {...svgProps} />
      case SvgType.SUBMIT:
        return <Submit className={className} {...svgProps} />
      case SvgType.PIN_PLUS:
        return <PinPlus className={className} {...svgProps} />
      case SvgType.PIN_X:
        return <PinX className={className} {...svgProps} />
      case SvgType.TRASH:
        return <Trash className={className} {...svgProps} />
      case SvgType.ARCHIVE:
        return <Archive className={className} {...svgProps} />
      case SvgType.REPLAY:
        return <Replay className={className} {...svgProps} />
      case SvgType.LIVE:
        return <Live className={className} {...svgProps} />
      default:
        return <div />
    }
  }
  return renderIcon()
})
